import { root } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";

export default {
    name: "Breadcrumb",
    props: {
        word: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: false
        },
        subdomain: {
            type: String,
            required: false,
            default: "Dictionary Definitions"
        }
    },
    data() {
        return {
            homeLink: `${root.WWW}/`
        };
    },
    computed: {
        isAbbrSubdomain() {
            return getCurrentSubdomain() === "abbreviations";
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js